import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgList = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12.1111 11C12.7248 11 13.2222 11.4975 13.2222 12.1111C13.2222 12.7248 12.7248 13.2222 12.1111 13.2222C11.4975 13.2222 11 12.7248 11 12.1111C11 11.4975 11.4975 11 12.1111 11Z",
			fill: "currentColor",
			stroke: "currentColor",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18 12H31",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.1111 19C12.7248 19 13.2222 19.4975 13.2222 20.1111C13.2222 20.7248 12.7248 21.2222 12.1111 21.2222C11.4975 21.2222 11 20.7248 11 20.1111C11 19.4975 11.4975 19 12.1111 19Z",
			fill: "currentColor",
			stroke: "currentColor",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18 20H31",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.1111 27C12.7248 27 13.2222 27.4975 13.2222 28.1111C13.2222 28.7248 12.7248 29.2222 12.1111 29.2222C11.4975 29.2222 11 28.7248 11 28.1111C11 27.4975 11.4975 27 12.1111 27Z",
			fill: "currentColor",
			stroke: "currentColor",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18 28H31",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgList);
export default ForwardRef;
